import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiPopover = {
  defaultProps: { disableScrollLock: true, elevation: 4 },
  styleOverrides: {
    paper: ({ theme }) => ({
      border: '1px solid var(--mui-palette-divider)',
      borderRadius: '12px',
      boxShadow: theme.shadows[4],
    }),
  },
} satisfies Components<Theme>['MuiPopover'];
